import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { TAddGuildParams } from '../actions/guildActionCreator';
import {
  CLEAR_QUEUE_MODAL_ERROR,
  SET_QUEUE_MODAL_ERROR,
  SET_QUEUE_MODAL_IS_LOADING,
  SET_QUEUE_MODAL_IS_OPEN,
  SET_QUEUE_MODAL_PARAMS,
  SET_QUEUE_MODAL_TAB,
  TQueueModalTab
} from '../actions/queueModalActions';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

type TQueueModalErrors = {
  inputFields?: any[];
  body?: string;
};

export type TQueueModalStatus = 'selecting' | 'processing' | 'complete' | 'failed' | 'error';

export type TQueueModalState = {
  errors: TQueueModalErrors;
  tab: TQueueModalTab;
  isLoading: boolean;
  batchId?: string;
  status: TQueueModalStatus;
  isOpen: boolean;
  queuedEntity?: string;
  queuedRealm?: string;
  batchInfo?: TAddGuildParams;
};

const defaultState: TQueueModalState = {
  errors: {},
  tab: 'guild',
  isLoading: false,
  status: 'selecting',
  isOpen: false
};

export default function queueModalReducer(
  state: Partial<TQueueModalState> = defaultState,
  action: TAction<any>
): Partial<TQueueModalState> {
  switch (action.type) {
    case SET_QUEUE_MODAL_TAB:
      return {
        ...state,
        tab: action.payload
      };
    case SET_QUEUE_MODAL_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };
    case SET_QUEUE_MODAL_ERROR:
      return {
        ...state,
        errors: action.payload
      };
    case SET_QUEUE_MODAL_IS_OPEN:
      const isOpen: boolean = action.payload;

      // Closing
      if (state.isOpen && !isOpen) {
        return {
          ...state,
          status: 'selecting',
          errors: {},
          isOpen: false
        };
      }

      return {
        ...state,
        isOpen
      };
    case CLEAR_QUEUE_MODAL_ERROR:
      return {
        ...state,
        errors: {}
      };
    case SET_QUEUE_MODAL_PARAMS:
      return {
        ...state,
        ...action.payload
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        errors: {},
        isOpen: false
      };
    default:
      return state;
  }
}
